module.exports = __webpack_public_path__ + "img/digital_check.61c699c6.png";